import * as React from 'react';
import {Helmet} from 'react-helmet';
import {useRoute} from 'react-router5';
import useLoading from '../../hooks/use-loading';
import validateResponse from '../../helpers/validate-response';
import isError from '../../helpers/isError';
import {toast} from 'react-toastify';
import {ProgramObject, FoodItem} from '../../api/program/types';
import {getProgram, editProgram} from '../../api/program/requests';
import {FoodBuilder} from '../../components/FoodBuilder';

/**
 * Edit the exercise page.
 * @return {React.ReactElement}
 * @constructor
 */
export default function EditFood(): React.ReactElement {
  const {data, fetch, render} = useLoading<ProgramObject<FoodItem>>();
  const {route, router} = useRoute();

  React.useEffect(() => {
    fetch(() => new Promise((resolve) => (
      getProgram<FoodItem>(route.params.foodId).then((response) => {
        validateResponse(response);

        if (response && !isError(response)) {
          resolve(response);
        }
      })
    )))
  }, [route.params.foodId]);

  /**
   * Render content.
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    return (
      <FoodBuilder
        defaultValue={data}
        onUpdate={(training) => (
          editProgram('eat', training).then((response) => {
            validateResponse(response);

            if (response && !isError(response)) {
              toast.success('Программа обновлена');
              router.navigate('foods');
            }
          })
        )}
      />
    );
  }

  /**
   * Render not found.
   * @return {JSX.Element}
   */
  function renderNotFound(): JSX.Element {
    return (
      <React.Fragment />
    );
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>FitPlace / Редактировать программу питания</title>
      </Helmet>
      {render(renderContent, renderNotFound)}
    </React.Fragment>
  );
}
